export const TYPE = {
  REPS_TO_APPROVE: 'reps_to_approve',
  DOCUMENT_APPROVED: 'document_approved',
  DOCUMENT_REJECTED: 'document_rejected',
};

export const TOKENS = {
  PLAIN: 'plain',
  STRONG: 'strong',
  GALLERY: 'gallery',
  APPROVAL_DOCUMENT: 'approval-document-title',
  REJECT_REASON: 'reject-reason-title',
};
